import React, { useContext, useState, useCallback, useEffect } from "react";
import { UseEkloks } from "../../api/eklok/Eklok.api";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useHistory } from "react-router";
import useUpdateEkloks from "../../hooks/useUpdateEkloks";
import { Fragment } from "react";
import { UseMe } from "../../api/users/Me.api";

const ListEkloksContainer = ({ children }) => {
  const history = useHistory();
  const [item, setItem] = useState(null);
  const [addAction, setAddAction] = useState(false);
  const { token } = useContext(AuthContext);
  const { content, loading, error } = UseEkloks(token);
  const { content: user } = UseMe(token);
  const [updateStatus, reloadEkloks, isPending] = useUpdateEkloks(
    token,
    content ? content : [],
  );
  const [date, setOpenDate] = useState(null);

  const onConnectDevice = useCallback((item) => {
    setOpenDate(new Date().getTime());
    setItem(item);
  }, []);

  const onCloseDevice = useCallback(() => {
    setOpenDate(null);
    setItem(null);
  }, []);

  const onViewAllAction = useCallback(() => {
    history.push("/app/ekloks");
  }, [history]);

  const onUpdateRowsAndPages = useCallback(
    (items) => {
      reloadEkloks(items.map((item) => item.id));
    },
    [reloadEkloks],
  );

  useEffect(() => {
    if (user && user.groups) {
      switch (user.groups[0].name) {
        case "Customer":
          setAddAction(true);
          break;
        default:
          setAddAction(false);
          break;
      }
    }
  }, [user]);

  return (
    <Fragment>
      {error ? <Error message={error.message} /> : null}
      {loading ? <Loading /> : null}
      {children({
        item,
        onConnectDevice,
        onCloseDevice,
        onViewAllAction,
        onUpdateRowsAndPages,
        content,
        updateStatus,
        addAction,
        date,
        isPending
      })}
    </Fragment>
  );
};

export default ListEkloksContainer;
